export interface Testimonial {
  id: number
  name: string
  image: string
  rating: number
  text: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Sarah Johnson',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    rating: 5,
    text: 'High View Travels delivered an exceptional 12-day Thailand cultural immersion experience. Their attention to detail, local expertise, and seamless logistics exceeded our expectations. The personalized itinerary perfectly balanced adventure with cultural authenticity.',
    location: 'Thailand Cultural Tour'
  },
  {
    id: 2,
    name: 'Michael Chen',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    rating: 5,
    text: 'As a frequent business traveler, I appreciate professionalism and reliability. High View\'s Bali retreat package was flawlessly executed with premium accommodations, private transportation, and knowledgeable local guides. Highly recommended for discerning travelers.',
    location: 'Bali Executive Retreat'
  },
  {
    id: 3,
    name: 'Emma Davis',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    rating: 5,
    text: 'Our Maldives honeymoon was orchestrated to perfection by High View Travels. From overwater villa selection to private dining experiences, every detail reflected their commitment to creating unforgettable luxury travel experiences. Truly exceptional service.',
    location: 'Maldives Honeymoon Package'
  }
]
